import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build tag: 2026-06-06-cdnbust-001 — forces a new JS bundle hash to bypass
// any stale Cloudflare cache entries pointing to a non-existent asset.
const __BUILD_TAG = "2026-06-06-cdnbust-001";
if (typeof window !== "undefined") {
  window.__ATF_BUILD = __BUILD_TAG;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
